/* eslint-disable no-nested-ternary */
import { Button, Chip, Container, Divider, Icon, Paper, Typography } from '@mui/material';
import DataTable from '../../common/DataTable';
import Header from '../../common/Header/Header';
import CreateAdminContainer from '../../../containers/CreateAdmin';
import styles from './styles';
import { AdminsProps } from './types';
import Filter from '../../common/Filter';
import AdminFilterModal from '../../AdminFilterModal';
import NoResultsFound from '../../common/NoResultsFound';
import Loading from '../../common/Loading';

const periodLabels: { [key: string]: string } = {
    LastWeek: 'Last Week',
    Last14Days: 'Last 14 Days',
    LastMonth: 'Last Month',
    LastQuarter: 'Last Quarter',
};

const AdminManagement = ({
    user,
    tableData,
    columns,
    loadMore,
    hasMore,
    setOpenProfileDetails,
    openProfileDetails,
    roles,
    createAdmin,
    setCreateAdmin,
    onFlitersApplyClick,
    onFlitersClearClick,
    selectedRole,
    selectedStatus,
    selectedPeriod,
    onStatusChange,
    onPeriodChange,
    onRoleChange,
    onFilterChipDelete,
    searchChange,
    handleRowClick,
    setReload,
    adminsCount,
    loader,
    sortData,
}: AdminsProps) => {
    const onChipDelete = (type: 'status' | 'role' | 'additionPeriod') => {
        if (onFilterChipDelete) {
            onFilterChipDelete(type);
        }
    };
    return (
        <Container sx={styles.container} maxWidth={false}>
            <Header
                profileImg={user.profileImg}
                name={user.name}
                titleComponent={
                    <Typography id="admin_users_title" component="div" sx={styles.header}>
                        <Typography component="div" sx={styles.title}>
                            Admin Users
                        </Typography>
                        <Typography id="admin_users_count" component="div" sx={styles.count}>
                            {adminsCount > 0 && adminsCount}
                        </Typography>
                    </Typography>
                }
                setOpenProfileDetails={setOpenProfileDetails}
                openProfileDetails={openProfileDetails}
            />
            <Paper elevation={1} sx={styles.table}>
                <Typography component="div" sx={styles.admin}>
                    <Typography component="div">
                        <Filter
                            id="admin-search"
                            onApplyFiltersClick={onFlitersApplyClick}
                            onFiltersClearClick={onFlitersClearClick}
                            placeholder="Search admin..."
                            searchChange={searchChange}
                            modalContent={
                                <AdminFilterModal
                                    roles={roles.map((x) => ({ id: Number(x.value), role: x.name }))}
                                    selectedRole={selectedRole}
                                    selectedStatus={selectedStatus}
                                    selectedPeriod={selectedPeriod}
                                    onPeriodChange={onPeriodChange}
                                    onRoleChange={onRoleChange}
                                    onStatusChange={onStatusChange}
                                />
                            }
                        />
                    </Typography>
                    <Typography component="div" sx={styles.selectedFilters}>
                        {selectedStatus && (
                            <Chip
                                id="statusChip"
                                sx={styles.chip}
                                color="primary"
                                onDelete={() => onChipDelete('status')}
                                label={selectedStatus === 'active' ? 'Active' : 'Inactive'}
                                variant="outlined"
                                deleteIcon={
                                    <Icon sx={styles.chipDelete}>
                                        <img alt="" src="./images/chip-delete.svg" />
                                    </Icon>
                                }
                            />
                        )}{' '}
                        {selectedRole !== -1 && (
                            <Chip
                                id="roleChip"
                                sx={styles.chip}
                                color="primary"
                                onDelete={() => onChipDelete('role')}
                                label={roles?.filter((x) => x.value === selectedRole)[0]?.name}
                                variant="outlined"
                                deleteIcon={
                                    <Icon sx={styles.chipDelete}>
                                        <img alt="" src="./images/chip-delete.svg" />
                                    </Icon>
                                }
                            />
                        )}{' '}
                        {selectedPeriod && (
                            <Chip
                                id="periodChip"
                                sx={styles.chip}
                                color="primary"
                                onDelete={() => onChipDelete('additionPeriod')}
                                label={periodLabels[selectedPeriod as string]}
                                variant="outlined"
                                deleteIcon={
                                    <Icon sx={styles.chipDelete}>
                                        <img alt="" src="./images/chip-delete.svg" />
                                    </Icon>
                                }
                            />
                        )}
                    </Typography>

                    <Button
                        id="add_admin"
                        sx={styles.addAdminButton}
                        disableRipple
                        onClick={() => setCreateAdmin(true)}
                    >
                        Add New Admin
                        <Typography component="img" alt="add admin" src="./images/add.svg" sx={styles.addIcon} />
                    </Button>
                </Typography>

                <Divider sx={styles.divider} />
                {loader ? (
                    <Loading />
                ) : tableData.length === 0 ? (
                    <NoResultsFound />
                ) : (
                    searchChange &&
                    tableData.length > 0 && (
                        <DataTable
                            columns={columns}
                            data={tableData}
                            loadMore={loadMore}
                            hasMore={hasMore}
                            handleRowClick={handleRowClick}
                            sortData={sortData}
                        />
                    )
                )}
            </Paper>
            {createAdmin ? (
                <CreateAdminContainer
                    createAdmin={createAdmin}
                    setCreateAdmin={setCreateAdmin}
                    roles={roles}
                    setReload={setReload}
                />
            ) : null}
        </Container>
    );
};

export default AdminManagement;
